/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.design) {
    draft.design = {};
  }
  draft.design.selectedProduct = null;
}), false, { type: 'RESET_SELECTED' });
